import * as pdpReducer from "./pdp.reducer";
import * as plpReducer from './plp.reducer';
import * as global from './global';

import { combineReducers } from "redux";

export default combineReducers({
    ...pdpReducer,...plpReducer,...global
})